import { createSelector } from 'reselect'
import {
  networkGroup,
} from '@nocode-works/template/store/selectors/utils'
import routerSelectors from '@nocode-works/template/store/selectors/router'

const templates = state => state.template.templates
const allTemplates = state => state.template.allTemplates
const versions = state => state.template.versions

const viewTemplate = createSelector(
  routerSelectors.params,
  templates,
  (params, templates) => templates.find(t => t.id == params.id)
)

const selectors = {
  templates,
  allTemplates,
  versions,
  viewTemplate,
  ...networkGroup('template', [
    'list',
    'get',
  ])
}

export default selectors
